<template>
	<div class="view-content__wrapper">
		<div class="view-content d-block d-sm-flex">
			<div class="permission-view mx-auto">
				<h1
					class="headline-1 graybase--text mb-8"
					:class="$vuetify.theme.dark ? 'grayscale100--text' : 'graybase--text'">
					{{ $t("verify_data.title") }} 
				</h1>
				<p
					class="body-3 mb-8"
					:class="$vuetify.theme.dark ? 'grayscale100--text' : ''">
					<span>{{ $t("verify_data.description") }} </span>
					<a
						:href="helpArticleUrl"
						target="_blank">{{ $t('verify_data.read_more') }}
					</a>
				</p><div class="permission-footer permission-footer--left mt-6">
					<div>
						<e-button
							:block="false"
							type="submit"
							variant="tertiary"
							size="large"
							large
							@click="skip()">
							{{ $t("verify_data.skip") }}
						</e-button>
					</div>
					<div class="ml-4">
						<e-button
							:block="false"
							type="submit"
							variant="primary"
							size="large"
							large
							@click="goToProfile()">
							{{ $t("verify_data.go_to_profile") }}
						</e-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	data () {
		return{
		}
	},
	computed:{
		...mapGetters([
			'getRedirectBusy',
			'getRedirectSuccess',
			'redirectUrl',
		]),
		helpArticleUrl (){
			return this.$i18n.locale == 'en' ? 'https://help.ekool.eu/en_US/getting-started/user-profile' : 'https://help.ekool.eu/et_ET/getting-started/user-profile'
		},
	},
	mounted () {
	},
	methods: {
		skip (){
			const target = 'home'
			this.$store.dispatch('getRedirect', { target }).then(
				() => {
					if(this.redirectUrl){
						window.top.location.href = this.redirectUrl
					}
				},
			)
		},
		goToProfile (){
			const target = 'profile'
			this.$store.dispatch('getRedirect', { target }).then(
				() => {
					if(this.redirectUrl){
						window.top.location.href = this.redirectUrl
					}
				},
			)
		},
	},
};
</script>